module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER THREE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENN GRABBED ANOTHER ROCK")])]), _vm._v(" from the pile and added it to the fire ring with a worried glance toward the other cabin. “He’s watching you,” she whispered to Chloe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s probably watching you,” Chloe answered with a distracted frown. “But I thought you wanted him to watch me,” she continued. Jenn watched her scoop up a handful of sand and let it drift through her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now I’m suspicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hot guy checking me out? I don’t blame you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn rolled her eyes. “Shut up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe just sifted more sand, her brow furrowed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aren’t you having fun?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?” Chloe glanced up and her face cleared a little. “No, I’m having fun! This is great. Very relaxing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Relaxing, huh? I was hoping we’d make it all the way to Funtown.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Chloe laughed, but Jenn regretted her words as soon as they left her mouth. “Funtown! God, I ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("haven’t heard that in forever. I never see Anna anymore. Maybe we should’ve invited her, too.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mmm,” Jenn answered, trying for nonchalance, wishing she hadn’t mentioned anything associated with Anna Fenton. “You know how busy she’s been with her job. I hardly see her anymore, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She could’ve gotten off work if she’d wanted to. Her dad owns the damn hotel chain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah…” Jenn’s heart thundered in her chest as the weight of her lies pressed down on her. She shook her hair back, hoping to shake off the worry, as well. This vacation was meant to be fun, and she assured herself that everything would be fine. “I think he’s grooming Anna to take over the kingdom or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too bad. It would’ve been nice. Like revisiting college. You two could’ve shared a room, and I would drop by at inconvenient times to sprawl on your bed and mope about boy trouble!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That does sound vaguely familiar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, we’ll have to all get together again soon. After the trial. She can help with my makeover. I need her to tell me which era is back in style. You’re as hopeless as I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I just go to Ann Taylor and let them sell me stuff.” Jenn rolled the last stone into place and dusted off her hands. “Anyway—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("“Why did she decide not to go to culinary school? ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("I haven’t talked to her since she was looking at applications last November.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn wanted to drop the subject, but she didn’t want to look suspicious, either. “She didn’t decide. Her dad told her that working in the kitchen was a good experience for a woman who was going to own a dozen luxury hotels someday, but she’d become a chef over his dead body.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, yikes. I had no idea. How’s she taking that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” Jenn answered with a forced smile. Chloe had never been as close to Anna as Jenn was, thank God, or there would’ve been no way to cover up this disaster. “Anyway, what’s the big deal? I’m not enough for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re enough for me. Plus, she probably wouldn’t have been able to relax without cell access. But it sounds like she needs a vacation as much as I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn pushed up from her knees to dust off the sand. “I saw a bunch of driftwood at that first dune. I’ll be right back.” Even though Chloe lay back on the cooling sand as if she didn’t have a care in the world, Jenn breathed a sigh of relief as she hurried off.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("She wasn’t cut out for deceit and never had been. As a kid, when she’d lied to her parents, all it had taken was one stern look from her dad to break her, ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("forcing a weeping confession. Now the tears seemed to push behind her eyes, waiting for a chance to escape.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it was too late to confess. There was no point. Chloe needed to move on and Jenn was going to help her do just that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna couldn’t understand that. She’d tried to convince Jenn that this time on the island would be a great opportunity to clear the air, get the truth out. Jenn had pretended to consider it, but, in reality, she wanted the truth buried under a hundred feet of earth where air would never touch it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn stole a look over her shoulder at Chloe stretched out on the sand, the slanting rays of the setting sun gleaming over her. Chloe deserved to be happy again. Jenn was determined to make that happen, even if it meant lying for the rest of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Speaking of happiness… She used the excuse of bending down for wood to angle her head toward the other cabin. Sure enough, that guy was staring hard at Chloe, forehead creased in thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Jenn frowned at him. What could he be thinking about? Did he recognize Chloe? The whole point of this stupid getaway had been to hide Chloe away from prying eyes so she could take a deep breath before the charges were filed, because that was going to be a complete nightmare. Hints were starting to ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("come out that Thomas had done more than just fake his own death…")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn wanted to give her friend a little peace before the trauma. And maybe all that other talk would just die down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clutching the wood to her chest, Jenn hurried back toward the cabin, keeping her eye on the man next door. He was still frowning at Chloe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Crap. She wanted Chloe to have a good time, but what if Jenn pushed her toward this guy and he really was a reporter?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before Jenn could intercept him, he stood and stepped onto the sand.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HLOE OPENED HER EYES")]), _vm._v(" to find a man standing over her, profile orange in the rays of the setting sun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello,” the man said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She propped herself up on her elbows. “Hello, yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My name’s Max Sullivan. My brother, Elliott, and I are staying next door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he extended a hand, Chloe shook it, then gave it a little tug to hint that she wanted up. Max pulled and she jumped to her feet with hardly any effort at all.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("“I noticed,” she said. “It’s nice to meet you, Max. I’m Chloe. This is Jenn.” She gestured toward Jenn, ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("who was rushing forward with an armful of wood as if she were planning to storm a castle with a battering ram.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced over his shoulder, then dropped Chloe’s hand and swung toward Jenn, saying, “Hey, let me help with that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe felt a twinge of unwarranted disappointment when he hurried toward her friend and swept all the driftwood out of her arms. He was probably interested in Jenn, like so many men were. But, sadly, Jenn was a waste of adorable blondness as far as Chloe was concerned. She was shy around guys, and only got more anxious the more attentive they became.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But maybe she liked this guy. Oh, well. Easy come, easy go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn’s face pinched into worry as Max smiled at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is Max,” Chloe said hurriedly. “One of our next-door neighbors. He came over to say hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi,” Jenn offered quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max winked and carried the wood to a spot about ten feet from the fire ring, dropping most of it on the sand before he carried a few pieces toward the pit. “So what are you ladies doing out here in the wilds of Virginia?” he asked as he began rearranging stones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing,” Jenn said loudly. “Just relaxing.”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, she wasn’t normally "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" nervous around guys. Chloe shot her a questioning look, but Jenn ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their neighbor scooped more sand out of the pit until the bottom was wide and flat and dark with moisture. “Elliott and I are out here fishing.” He tossed five small pieces of wood into the hole, then added one large one to the top before reaching toward the lighter Chloe had left there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s not going to make a very big fire,” Chloe muttered. The man shot her an amused smile as if that answered her complaint.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you do for a living?” Jenn blurted out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His brows rose, drawing Chloe’s attention to his dark brown eyes. Nice. When he began to twist up one of the supermarket circulars she’d brought out as kindling, her focus moved from his eyes to his wide, strong hands. Very nice. “I work on the water,” he answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Doing what?” Jenn’s eyes narrowed suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m an officer on a research vessel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where?” she prodded.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Chloe frowned at her rudeness until Jenn made a picture-taking gesture behind Max’s back. Chloe rolled her eyes and shook her head. No way was this guy with one of the gossip rags. He looked healthy ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("and muscular, not like a man who spent 90 percent of his life huddled outside the doors of L.A. nightclubs. Also, he didn’t have a cigarette dangling from his mouth.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max was hunched over the fire, coaxing a weak flame to grow to something that would take hold of the wood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe cleared her throat. “I really don’t think that’s going to keep us warm once the sun sets.” Little fingers of fire worked over the tiny bits of driftwood, inching slowly toward the larger piece.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can add more later. It’ll burn better if you start small.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you some sort of beach party expert?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve had my fair share of sand down my shorts,” he drawled, finally glancing up from his task. Those brown eyes crinkled when he smiled, and Chloe felt her insides melt at the sight. Was he flirting with her? Or had he looked at both women with the same amount of warmth?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t be angry if he was just spreading his luck around. After all, they’d discussed the men as interchangeable parts just a few hours before.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("His gold-streaked hair curled onto his brow on a gust of wind, and Max dusted off those big hands and shoved it back, his arm muscles making interesting shadows as he moved. She sat down and helpfully patted the ground next to her, happy when he ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("dropped down and propped his arms on his knees. “What kind of research do you do?” she asked.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We, um…” His smile edged toward sheepishness. “We locate and map out previously uncharted shipwrecks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, we’re usually in the Mediterranean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What kind of wrecks?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He laughed, a deep chuckle that spoke of good humor and friendship. “Mostly the kind that have gold in them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh!” Chloe gasped. “You’re a treasure hunter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even Jenn gave up her suspicious glare and looked surprised at that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We prefer to think of ourselves as researchers bringing long-lost artifacts out of the depths and back into the world where they belong.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, so you give all the loot to museums?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That smile again. Wow. “We do our best to find dives in international waters, but even we wouldn’t keep the historically significant artifacts for our own profit. For the most part.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("Chloe laughed, but when his gaze fell to her mouth, a little shiver of nervousness jumped through her stomach. The thick piece of driftwood crackled weakly as the fire finally latched on to it. Chloe used it as an excuse to look away. “We’d better move back, ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("Max. That inferno could jump out of control at any moment.”")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My point exactly.” But in acknowledgment of her mockery, he grabbed the last piece he’d brought close to the pit and laid it carefully on the fire, angling a challenging look in her direction. The twisted piece of driftwood was half the size of the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good Lord, this man was quirky. And cute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what do you do for a living?” he asked, turning his head toward Jenn, the original interrogator.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m a CPA.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eyebrows raised, he turned back to Chloe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Me, too,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wow. Accountants. That’s…sexy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, right,” she laughed. “That’s the first I’ve heard of it. How about you, Jenn?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Definitely a first.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on. Number-geek girls? That’s hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe shook her head, flabbergasted. “That’s the worst pickup line ever! You have to at least say something we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("might")]), _vm._v(" believe. Just because we’re accountants doesn’t mean we’re desperate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max leaned back, a frown twisting his mouth. “That’s not a pickup line! Jeez. Do you think every strange man who wanders into your private party uninvited is just trying to pick you up?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laughing, she shook her head.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("“Maybe I just saw you in your bikini and thought ")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("‘There’s a girl who’d want to talk baseball over beers.’ Did you ever consider that?”")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she managed past a wide grin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pickup line,” he muttered in mock bitterness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When her giggles subsided, Chloe thought about buttoning up her shirt. She was wearing shorts, but felt suddenly, hotly aware that her stomach was exposed from her navel all the way to her blue, halter-style bikini. But that would be too obvious as she was still casually propped up on her elbows, so Chloe arched her back a tiny bit to smooth out any unfortunate creases. The skin on her stomach sizzled when his eyes drifted down before he cleared his throat and looked at the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anyway, now that I’ve successfully played caveman—” his hand tilted toward the flames before he pushed to his feet “—I’ll leave you to your evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe looked up at him, wondering if he was a little over six feet tall or if her perspective was throwing off her estimate. Aw, who the heck cared? The faint apprehension winding up her gut was a far more pleasant sensation than the one she normally felt. Chloe decided to go for it. “We’ve got marshmallows. You and your brother are welcome to help us roast them if you think we’re not up to the task.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("His gaze flickered down to her stomach again. ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("He seemed to consider her offer carefully before answering. “Well…there is a fine line between pleasantly burned and marshmallow conflagration.”")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So true.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d hate to leave and then find out later that everything went horribly wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe smiled in a way she hadn’t smiled at a man in a long time. “Exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He matched her friendliness with a spectacular smile of his own. “All right. I’ll grab Elliott and some beers and be back in a few minutes. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She maintained her smile as he walked away. It wasn’t hard. He presented a very nice picture in retreat. Without looking away from Max’s ass, Chloe asked, “What the heck’s wrong with you, Jenn?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw him watching you from their porch. I worried that he’d recognized you. He could be a photographer, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If he brings his camera back with him, we’ll know for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A reporter then,” Jenn insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look at him. Have you seen even one newspaper reporter who looks like that? He looks exactly like a man who’s spent months on a boat in paradise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s true.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("“Thanks for trying to watch out for me, sweetie. You’re the best friend in the world. But I’m starting to think your original plan was a good idea. Vacation ")]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("relaxation helped along by some illicit island love, remember?”")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn’s face finally brightened. “You know what? You’re right. He’s not a reporter. And he’s hot. You should go for it. Absolutely. Get your groove back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Was he really watching me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like, in a good way? Or in a ‘I wonder if her dismembered limbs will fit into my duffel bag’ way?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was frowning, actually, so I was wondering what he was thinking. But maybe he was just coming up with awful pickup lines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe waved a hand before scrambling up to her feet. “He probably thinks I look vaguely familiar but can’t place me. I get that a lot these days. Luckily, there’s no one around to clue him in…unless his brother recognizes me. But whatever.” She took a deep breath. “I’m Island Chloe, right? The girl without a care in the world?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes!” squealed Jenn, pumping her fist into the air in victory. “Funtown, here we come!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe just a short trip.” Chloe lifted her chin high. “And now I am going to go put on some clothes, so I can stop holding in my gut.”")])])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page44"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0daa9d3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crazyforlove_ch03.vue
// module id = 87
// module chunks = 0